import React from 'react';
import { withRouter } from 'react-router';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import Chart from './chart';
import ListHeader from './list-header';
import ExportRaw from './export-raw'; 
import Reports from './reports';
import './list.scss';


const StatisticsList = props => {
    const handleChange = (e) => {
      const val = e.target.value;
      props.history.push(val);
    };

    const hasMultipleCompanies = props.branches.filter(branch => !branch.connectedToMainCompany);

    return (
        <section className="statstics-list">
            <div className="statstics-list__container">
              <div className="statstics-list__content">
                {props.branches.map((item, i) => {
                  return (
                      <div key={`statistics${item.id}${i}`} className="statstics-list__item">
                        <Chart fetch={props.fetch} branchId={item.access.branch.id} companyId={item.access.company.id} companyName={item.access.company.name} />
                        <div className="statstics-list__item-content">
                            <header className="statstics-list__item-header">
                                <div className="statstics-list__item-header-left">
                                    <h2 className="statstics-list__category">{(hasMultipleCompanies && hasMultipleCompanies.length > 0)  && <>Företag: {item.company.name} • </>}Gren:</h2>
                                    <ListHeader {...item} />
                                </div>
                                {item.access.reportWriter &&
                                  <div className="statstics-list__item-header-right">
                                      <a className="form__button form__button--small" href={`/company/${item.access.company.id}/branch/${item.access.branch.id}/period/${item.activePeriod.id}`}>Rapportera</a>
                                      <label className="form__button form__button--small form__button--outline statstics-list__report-other">
                                        {item.periods.filter(period => period.estimated).length > 0 &&
                                          <div className="statstics-list__estimated" title={`Du har ${item.periods.filter(period => period.estimated).length} skattade perioder att hantera.`}>{item.periods.filter(period => period.estimated).length}</div>
                                        }
                                        <div className="statstics-list__report-other-inner">
                                          <select onChange={e => handleChange(e)} defaultValue="">
                                            <option value="">Visa/ändra tidigare</option>
                                            {item.periods.map(period => {
                                              return <option key={period.id} value={`/company/${item.access.company.id}/branch/${item.access.branch.id}/period/${period.id}`}>{period.name} {period.year}{period.estimated && ' (Skattad)'}</option>
                                            })}
                                          </select>
                                        </div>
                                      </label>
                                  </div>
                                }
                            </header>
                            <nav className="statstics-list__item-nav">
                                <ul className="statstics-list__item-links">
                                    {item.access.reportReader &&
                                      <Reports {...item} branchId={item.access.branch.id} companyId={item.access.company.id}  />
                                    }
                                    {item.access.reportExport &&
                                      <li>
                                        <ExportRaw fetch={props.fetch} branchId={item.access.branch.id} companyId={item.access.company.id} name={item.name} />
                                      </li>
                                    }                                    
                                </ul>
                            </nav>
                        </div>
                        <div className="statstics-list__item-footer">
                            <nav className="statstics-list__item-nav">
                                <ul className="statstics-list__item-links">
                                  {item.access.reportReader &&
                                    <Reports {...item} branchId={item.access.branch.id} companyId={item.access.company.id}  />
                                  }
                                  {item.access.reportExport &&
                                    <li>
                                      <ExportRaw fetch={props.fetch} branchId={item.access.branch.id} companyId={item.access.company.id} name={item.name} />
                                    </li>
                                  }
                                </ul>
                            </nav>
                        </div>
                    </div>
                  );
              })}
            </div>
          </div>
        </section>
    );
};

export default withAuthProvider(withFetch(withRouter(StatisticsList)));